// import { Box, Chip, IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { Divider, Stack, Typography } from '@mui/material';
import { HiCurrencyDollar, HiTrendingUp } from 'react-icons/hi';
import { HiOutlineWallet } from 'react-icons/hi2';
// import { useMemo, useState } from 'react';
// import { HiChevronDown } from 'react-icons/hi';

// import { formatAmount } from '@/helpers/coins';
import { TODAY_DATE_RANGE } from '@bitstopco/bitstop-theme/constants';

// import { CoinIcon } from '@/components/wallets/CoinIcon';
import { useGetPrecioQuery } from '@/store/api/services/common/precio';
import { useGetSalesStatsQuery } from '@/store/api/services/common/sales';
import { useGetNodeWalletInfoQuery } from '@/store/api/services/common/wallet';
// import { useGetWalletsConfigQuery } from '@/store/api/services/wallets/wallets';
// import type { WalletCoin } from '@/types';

// type EnabledWallet = {
//   coin: WalletCoin;
//   ticker: string;
//   unicodeSymbol: string;
//   balance: string;
//   rawBalance: number;
//   chainName: string;
//   isActive: boolean;
// };

const headersStatsV1 = () => {
  // const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  // const [selectedWalletIndex, setSelectedWalletIndex] = useState(0);
  // const open = Boolean(anchorEl);

  const { data: sales } = useGetSalesStatsQuery({
    range_start: TODAY_DATE_RANGE.startDate?.toISOString(),
    range_end: TODAY_DATE_RANGE.endDate?.toISOString(),
  });
  const { data: precio } = useGetPrecioQuery();
  // const { data: walletsConfig } = useGetWalletsConfigQuery();
  const { data: nodeWalletInfo } = useGetNodeWalletInfoQuery();

  const totalSales = sales?.total_sales || 0;
  const price = precio?.formattedValue || '0';

  // const enabledWallets = useMemo((): EnabledWallet[] => {
  //   if (!walletsConfig?.data) return [];

  //   const wallets: EnabledWallet[] = [];
  //   for (const provider of walletsConfig.data) {
  //     for (const coin of provider.coins) {
  //       if (coin.is_enabled && coin.is_wallet_configured && coin.wallet) {
  //         const balance = coin.wallet.last_balance ?? 0;
  //         const { formatted } = formatAmount(balance, coin.decimals, 8);
  //         wallets.push({
  //           coin, // Store the full coin object for CoinIcon
  //           ticker: coin.ticker,
  //           unicodeSymbol: coin.unicode_symbol,
  //           balance: formatted,
  //           rawBalance: balance,
  //           chainName: coin.chain.name,
  //           isActive: coin.is_wallet_configured && coin.is_enabled,
  //         });
  //       }
  //     }
  //   }
  //   return wallets.sort((a, b) => b.rawBalance - a.rawBalance); // Sort by balance descending
  // }, [walletsConfig]);

  // const totalBalanceCount = enabledWallets.length;
  // const selectedWallet = enabledWallets[selectedWalletIndex] || enabledWallets[0];

  // Truncate balance for display if it's too long
  // const truncateBalance = (balance: string, maxLength = 12) => {
  //   if (balance.length <= maxLength) return balance;
  //   return `${balance.substring(0, maxLength)}...`;
  // };

  // const handleClick = (event: React.MouseEvent<HTMLElement>) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  // const handleWalletSelect = (index: number) => {
  //   setSelectedWalletIndex(index);
  //   handleClose();
  // };

  const statDivider = (
    <Divider
      orientation="vertical"
      flexItem
      sx={{ borderColor: 'rgba(255, 255, 255, 0.3)', my: 0.25 }}
    />
  );

  const iconStyle = { flexShrink: 0, opacity: 0.85 } as const;

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      rowGap={0.5}
      alignItems="center"
      justifyContent="inherit"
      spacing={{ xs: 1, sm: 2 }}
      divider={statDivider}
      sx={{
        color: 'primary.contrastText',
        '& span': {
          gap: '6px',
          lineHeight: 1,
          display: 'inline-flex',
          alignItems: 'center',
          whiteSpace: 'nowrap',
          fontSize: { xs: 11, sm: 12, md: 13 },
        },
      }}
      data-test="header-stats"
    >
      <Typography variant="caption">
        <HiCurrencyDollar size={14} style={iconStyle} />1 BTC = ${price}
      </Typography>
      <Typography variant="caption">
        <HiTrendingUp size={14} style={iconStyle} />
        Sales Today: {totalSales}
      </Typography>
      <Typography variant="caption">
        <HiOutlineWallet size={14} style={iconStyle} />
        Wallet Balance: ₿ {nodeWalletInfo?.balance || '0'}
      </Typography>

      {/* Multi-Coin Wallet Balance Display */}
      {/* <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {totalBalanceCount > 0 ? (
          <Tooltip
            title={
              totalBalanceCount > 1
                ? `Click to switch wallets (${selectedWalletIndex + 1}/${totalBalanceCount})`
                : selectedWallet.balance
            }
            placement="bottom"
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: totalBalanceCount > 1 ? 'pointer' : 'default',
                '&:hover': totalBalanceCount > 1 ? { opacity: 0.8 } : {},
              }}
              onClick={totalBalanceCount > 1 ? handleClick : undefined}
            >
              <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', mr: 0.5 }}>
                <CoinIcon coin={selectedWallet.coin} width={14} height={14} hideChain />
              </Box>
              <Typography
                variant="caption"
                sx={{ maxWidth: 80, overflow: 'hidden', textOverflow: 'ellipsis' }}
              >
                {truncateBalance(selectedWallet.balance)}
              </Typography>
              {totalBalanceCount > 1 && (
                <Chip
                  label={`${selectedWalletIndex + 1}/${totalBalanceCount}`}
                  size="small"
                  sx={{
                    ml: 0.5,
                    height: 16,
                    fontSize: '0.7rem',
                    backgroundColor: 'primary.main',
                    color: 'white',
                  }}
                />
              )}
            </Box>
          </Tooltip>
        ) : (
          <Typography variant="caption">No Wallets</Typography>
        )}

        {totalBalanceCount > 1 && (
          <IconButton
            size="small"
            onClick={handleClick}
            sx={{
              p: 0,
              ml: 0.5,
              color: 'inherit',
              '&:hover': { backgroundColor: 'transparent' },
            }}
          >
            <HiChevronDown size={12} />
          </IconButton>
        )}
      </Box> */}

      {/* Wallet Balance Dropdown Menu */}
      {/* <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            mt: 1,
            minWidth: 200,
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          },
        }}
      >
        <Box sx={{ px: 2, py: 1, borderBottom: '1px solid', borderColor: 'divider' }}>
          <Typography variant="caption" sx={{ fontWeight: 'bold', color: 'text.secondary' }}>
            Select Wallet to Display
          </Typography>
        </Box>
        {enabledWallets.map((wallet, index) => (
          <MenuItem
            key={wallet.ticker}
            onClick={() => handleWalletSelect(index)}
            selected={index === selectedWalletIndex}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              py: 1,
              px: 2,
              minHeight: 'auto',
              gap: 2,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
              <CoinIcon coin={wallet.coin} width={16} height={16} hideChain />
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                {wallet.chainName}
              </Typography>
            </Box>
            <Typography
              variant="caption"
              sx={{
                fontWeight: 'bold',
                maxWidth: 100,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                flexShrink: 0,
              }}
            >
              {wallet.balance}
            </Typography>
          </MenuItem>
        ))}
      </Menu> */}
    </Stack>
  );
};

export default headersStatsV1;
